<div class="error-container">
    <h1>Aviso</h1>
    <p>{{ errorMessage }}</p>
  </div>
  